<template>
  <div class="banner">
    <div class="container">
      <div class="banner__wrapper">
        <div class="banner__wrapper__left">
          <div class="banner__wrapper__left-top">
            <h3>{{ t('home.top-banner.title') }}</h3>
            <p>{{ t('home.top-banner.text')}}</p>
          </div>
          <div class="banner__wrapper__left-bottom">
            <ui-button>
              <router-link :to="translations.i18nRoute({ name: 'market' })">
                {{ t('buttons.viewAll') }}
              </router-link>
              <img src="@icons/rightArrowBlue.svg" alt="arrow">
            </ui-button>
            <ui-button @click="scrollTo('contact-us', 'home')">
                {{ t('home.contact.title') }}
              <img src="@icons/rightArrowBlue.svg" alt="arrow">
            </ui-button>
          </div>
        </div>
        <img src="@images/topBanner.png" alt="gift card" class="banner__wrapper-right">
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";
import UiButton from "@/components/ui/ui-button.vue";
import { scroll } from "@/core/helpers/scrollTo.js";

import {useRoute, useRouter} from "vue-router";

const route = useRoute();
const router = useRouter();

const {t} = useI18n()

const scrollTo = (id, routeName) => {
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({ name: "home" }).then(() => scroll(id, 300));
  }
};

</script>

<style scoped lang="scss">
h3{
  font-size: 28px;
  font-weight: 800;
  color: #3B3B3B;
}

p{
  font-size: 16px;
  color: #3B3B3B;
  line-height: 2;

}

button{
  color: #3B3B3B !important;
  border: #3B3B3B 1px solid !important;

  &:hover{
    box-shadow: 0 0 5px 1px #6F6DD3 !important;
  }
}

.banner{
  padding-top: 100px;

  &__wrapper{
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 45px;
    gap: 56px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);

    &__left{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      gap: 25px;

      &-top{
        border-bottom: 1px solid #DD6196;
        padding-bottom: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        gap: 20px;
      }

      &-bottom{
        display: flex;
        gap: 20px;
      }
    }
  }
}

@media (max-width: 1100px) {
  .banner__wrapper-right{
    display: none;
  }
}
</style>